import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { ILegalEntityLookup } from '../interfaces/ILegalEntityLookup';

/** Параллельные вызовы с тем же ИНН/ОГРН (двойной mount, reset формы) — один HTTP-запрос. */
const fnsLookupInFlightByInn = new Map<string, Promise<ILegalEntityLookup>>();
const fnsLookupInFlightByOgrn = new Map<string, Promise<ILegalEntityLookup>>();

export async function fetchFnsLookupByInn(inn: string): Promise<ILegalEntityLookup> {
  const cached = fnsLookupInFlightByInn.get(inn);

  if (cached) {
    return cached;
  }

  const promise = apiGet<ILegalEntityLookup>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/fns/lookup/inn/${inn}`,
  ).finally(() => {
    fnsLookupInFlightByInn.delete(inn);
  });

  fnsLookupInFlightByInn.set(inn, promise);

  return promise;
}

export async function fetchFnsLookupByOgrn(ogrn: string): Promise<ILegalEntityLookup> {
  const cached = fnsLookupInFlightByOgrn.get(ogrn);

  if (cached) {
    return cached;
  }

  const promise = apiGet<ILegalEntityLookup>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/fns/lookup/ogrn/${ogrn}`,
  ).finally(() => {
    fnsLookupInFlightByOgrn.delete(ogrn);
  });

  fnsLookupInFlightByOgrn.set(ogrn, promise);

  return promise;
}
